import { data } from "data/data"

export const useData = () => data
